import AttributeLookupResourcePagingResultModel from '../../generated/types/model/resource/AttributeLookupResourcePagingResultModel';

export default class AttributeLookupResourcePagingResultViewModel extends AttributeLookupResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
